import React from "react";
import { formatHouseType } from "app/containers/JobCalendar/utils/mapUtils";
import "./PropertyDetails.css";

// Figma order: two columns, read left-to-right.
const FIELDS = [
  { key: "yearBuilt", label: "Year Built" },
  { key: "squareFeet", label: "Square Feet" },
  { key: "numberOfStories", label: "Number of Stories" },
  { key: "houseType", label: "House Type", format: formatHouseType },
  { key: "parcelNumber", label: "Parcel Number" },
  { key: "note", label: "Note" },
];

const pick = (key, report, appointment) =>
  report?.[key] || appointment?.[key] || "";

export const toPropertyDetails = (report, appointment) => ({
  yearBuilt: pick("year_build", report, appointment),
  squareFeet: pick("floor_area", report, appointment),
  numberOfStories: pick("stories", report, appointment),
  houseType: pick("house_type", report, appointment),
  parcelNumber: pick("apn", report, appointment),
  note: pick("info", report, appointment),
});

const PropertyDetails = ({ details }) => {
  const visible = FIELDS.filter(({ key }) => details?.[key]);
  if (!visible.length) return null;

  return (
    <div className="job-property-details">
      {visible.map(({ key, label, format }) => (
        <div className="job-property-details-field" key={key}>
          <span className="job-property-details-label">{label}</span>
          <span className="job-property-details-value">
            {format ? format(details[key]) : details[key]}
          </span>
        </div>
      ))}
    </div>
  );
};

export default PropertyDetails;
